var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ctD-wrap"},[_c('canvas',{ref:"ctD",staticClass:"ctD",style:(_vm.styles),attrs:{"width":"200","height":"200"}},[_vm._v("浏览器不支持Canvas,请升级或改用其它浏览器！")])])}
var staticRenderFns = []

export { render, staticRenderFns }